module.exports = __webpack_public_path__ + "static/media/logo-external.5e163d21.png";